import { Box, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import food from '../../assets/challenges/food/vegetarian/vegemeal.png';
import transport from '../../assets/challenges/transport/mrt.png';
import utilities from '../../assets/challenges/utilities/electricityswitch/electricityswitch.png';
import Avatar from "../cards/Avatar";

export default function NewUserActions() {
    return (
        <Stack spacing={2}>
            <Box className='centered-container' sx={{ position: 'relative', borderRadius: 'var(--container-rad)', backgroundColor: 'var(--pri-purple)', p: 2, color: 'white', textAlign: 'center' }}>
                <Typography variant='body2'>
                    Congratulations on starting<br/> 
                    your carbon reduction journey!
                </Typography>
                <Stack direction={'row'} spacing={2} className="centered-y">
                    <Avatar level={0} style={{ maxWidth: 100, margin: 10 }} alt="Eco Explorer Avatar" />
                    <Box>
                        <Typography variant='caption'>
                            Your Starting Rank
                        </Typography>
                        <Typography variant='h5'>
                            <Avatar level={0} getImage={false} />
                        </Typography>
                    </Box>
                </Stack>
            </Box>
            
            <Typography variant="h5">
                How would you like to reduce your emissions?
            </Typography>
            <Typography variant="body2">
                Explore different categories of sustainable actions you can take to reduce your carbon emissions - and earn rewards for your efforts!
            </Typography>
            <CategoryCard photo={food} categoryTitle={'Food'} />
            <CategoryCard photo={transport} categoryTitle={'Transport'} />
            <CategoryCard photo={utilities} categoryTitle={'Utilities'} />
        </Stack>
    )
}

const CategoryCard = ({ photo, categoryTitle }) => {
    const navigate = useNavigate();
    return (
        <Stack direction={'row'}
            sx={{ 
                backgroundColor: 'var(--pri-green)', borderRadius: '32px', cursor: 'pointer',
                transition: 'box-shadow 0.5s, transform 0.5s',
                '&:hover' : {
                    transform: 'translate(-4px,-4px)',
                    boxShadow: '4px 4px var(--dark-green)'
                }
            }}
            onClick={()=>navigate(
                '/',
                { state: {
                    selectedCategory: categoryTitle
                }}
            )}
        >
            <Box sx={{ height: '150px', maxWidth: '50%', borderRadius: '32px 0 0 32px', aspectRatio: 1, background: `var(--light-green) url(${photo}) no-repeat center`, backgroundSize: 'cover' }} />

            <Box className='centered-container' sx={{ width: '100%', p: 2, textAlign: 'center' }}>
                <Typography variant='h6'>
                    { categoryTitle }
                </Typography>
            </Box>
        </Stack>
    )
}